import { render, staticRenderFns } from "./header-main.vue?vue&type=template&id=4ba5baba&scoped=true"
import script from "./header-main.vue?vue&type=script&lang=js"
export * from "./header-main.vue?vue&type=script&lang=js"
import style0 from "./header-main.vue?vue&type=style&index=0&id=4ba5baba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5baba",
  null
  
)

export default component.exports